import { render, staticRenderFns } from "./ListContractNew.vue?vue&type=template&id=1de5355d&"
import script from "./ListContractNew.vue?vue&type=script&lang=ts&"
export * from "./ListContractNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports